module.exports = __webpack_public_path__ + "media/images/illustrations/flat_welcome-935b18204068188e731e4f1045322970.png";